var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-loading"},[_c('van-overlay',{attrs:{"show":_vm.show}},[_c('div',{staticClass:"loading-wrap"},[_c('van-loading',{attrs:{"type":"spinner","vertical":""}},[_vm._v("加载中...")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }